import { render, staticRenderFns } from "./treasury.vue?vue&type=template&id=055d8269&"
import script from "./treasury.vue?vue&type=script&lang=js&"
export * from "./treasury.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports